var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { property } from 'lit/decorators.js';
import { css } from 'lit';
import { stringDecoder, PIC, PICInput } from '../Internals';
export class PICInputOptions extends PICInput {
    constructor() {
        super(...arguments);
        this.boundFldId_ = '';
        this.boundFldElm = null;
    }
    changeHandler(e) {
        if (this.boundFldElm && this.boundFldElm instanceof PICInputOptions) {
            this.boundFldElm.activeGroup = this.submitValue;
        }
        return super.changeHandler(e);
    }
    connectedCallback() {
        super.connectedCallback();
        let ref = this;
        if (!window.tmpPrevent) {
            window.tmpPrevent = true;
            PIC.getInstance.addEventListener('inputConnected', (iEvent) => {
                if (iEvent.detail.selfid && iEvent.detail.boundid) {
                    if (this.id_ == iEvent.detail.boundid)
                        setTimeout(() => {
                            let boundfld = PIC.getInstance.findElementByIdDeep(iEvent.detail.boundid), selffld = PIC.getInstance.findElementByIdDeep(iEvent.detail.selfid);
                            if (boundfld && selffld) {
                                boundfld.activeGroup = selffld.submitValue;
                            }
                        }, 7);
                }
            });
        }
        setTimeout(() => {
            if (ref.boundFldId_) {
                ref.boundFldElm = ref.boundFldElm = PIC.getInstance.findElementByIdDeep(ref.boundFldId_);
            }
            let lst = ref.getElementsByTagName('pic-optiongroup');
            for (let i = 0; i < lst.length; i++) {
                let observer = new MutationObserver(function (mutations) {
                    mutations.forEach(function (mutation) {
                        if (mutation.attributeName == "class") {
                            if (mutation.target.classList.contains('selected')) {
                                ref.optionContainer.parentData = { ref: null };
                                ref.optionContainer = mutation.target;
                                ref.optionContainer.parentData = { ref: ref };
                                ref.optionContainer.optHandler();
                                ref.requestUpdate();
                                //TODO Cry, then find another solution this is neccesary for LIT to update the submitValue when the option collection changes
                                if (ref.selectorElem)
                                    setTimeout(() => { ref['selectorElem'].dispatchEvent(new Event('change')); }, 5);
                            }
                        }
                    });
                });
                observer.observe(lst[i], { attributes: true });
            }
            this.optionContainer = this.getElementsByClassName('selected')[0];
            if (!this.optionContainer)
                this.optionContainer = this.getElementsByTagName('pic-optiongroup')[0];
            if (this.optionContainer) {
                let ref = this;
                let preventSelection = false;
                this.optionContainer.parentData = { ref: this };
                this.optionContainer.addEventListener('DataParsed', (e) => {
                    if (e.detail.preventSelection)
                        preventSelection = true;
                    ref.dataReady(preventSelection);
                });
                this.optionContainer.optHandler(preventSelection);
            }
            window.dispatchEvent(new CustomEvent('inputConnected', { detail: { selfid: ref.id_, boundid: ref.boundFldId_ }, bubbles: true, composed: true }));
        }, 5);
    }
    set activeGroup(iGroup) {
        let lst = this.getElementsByTagName('pic-optiongroup');
        for (let i = 0; i < lst.length; i++) {
            if (lst[i].id == iGroup)
                lst[i].classList.add('selected');
            else
                lst[i].classList.remove('selected');
        }
    }
    get activeGroupCount() {
        let lst = this.getElementsByTagName('pic-optiongroup');
        return lst.length;
    }
    get options() {
        if (this.optionContainer)
            return this.optionContainer.data;
        else
            return [];
    }
    get activeGroupHasValSub() {
        if (this.optionContainer)
            return this.optionContainer.hasValSubOption;
        return false;
    }
    static get styles() {
        const defaultStyle = css ``;
        return css `
            ${super.styles}
            ${defaultStyle}
        `;
    }
    dataReady(preventSelection) {
        if (this.boundFldElm && this.boundFldElm instanceof PICInputOptions) {
            if (this.boundFldElm.activeGroupCount > 1) {
                this.boundFldElm.activeGroup = this.submitValue;
            }
            else {
                this.boundFldElm.optionContainer.parms_ = this.submitValue;
                this.boundFldElm.optionContainer.getAndParseOptions(false, false, undefined, preventSelection);
            }
        }
    }
}
__decorate([
    property({ converter: stringDecoder, attribute: 'boundfld' })
], PICInputOptions.prototype, "boundFldId_", void 0);
//# sourceMappingURL=PICInputOptions.js.map